import { useState, useEffect } from "react";
import { FaStarOfLife } from "react-icons/fa6";
import { IoMdClose } from "react-icons/io";
import { FaPaperPlane } from "react-icons/fa";
import { BsSave2 } from "react-icons/bs";
import Button from "../Button";
import InputField from "../InputField";

const FormFields = ({
  fields,
  formData,
  handleInputChange,
  onSubmit,
  onClear,
  isEditing,
  onSubmitAndAddNew,
}) => {
  const [errors, setErrors] = useState({});
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    if (formData.image_Upload) {
      if (typeof formData.image_Upload === "string") {
        setPreviewUrl(formData.image_Upload);
      } else if (formData.image_Upload instanceof File) {
        const fileUrl = URL.createObjectURL(formData.image_Upload);
        setPreviewUrl(fileUrl);
      }
    } else {
      setPreviewUrl(null);
    }
  }, [formData.image_Upload]);

  const validateFields = () => {
    const newErrors = {};
    fields.forEach((field) => {
      const value = formData[field.name]?.toString().trim() || "";
      if (field.required && !value && field.type !== "file") {
        newErrors[field.name] =
          field.errorMessage || `${field.label} is required!`;
      }
      if (value && field.pattern && !field.pattern.test(value)) {
        newErrors[field.name] =
          field.errorMessage || `Invalid ${field.label} format`;
      }
      if (field.type === "number" && value) {
        if (field.min && Number(value) < field.min) {
          newErrors[field.name] =
            field.errorMessage || `Minimum value is ${field.min}`;
        }
        if (field.max && Number(value) > field.max) {
          newErrors[field.name] =
            field.errorMessage || `Maximum value is ${field.max}`;
        }
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChangeWithValidation = (val, field) => {
    const value =
      val?.target?.type === "file"
        ? val.target.files[0]
        : val?.target?.value ?? val?.value ?? val;
    const name = val?.target?.name ?? field.name;

    if (field.type === "file" && val?.target?.files?.[0]) {
      setPreviewUrl(URL.createObjectURL(val.target.files[0]));
    }

    handleInputChange({ target: { name, value } });

    setErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[name];
      return newErrors;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateFields()) onSubmit(e);
  };

  const handleSaveAndAddNew = (e) => {
    e.preventDefault();
    if (validateFields()) onSubmitAndAddNew?.(e);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="grid grid-cols-12 gap-4">
        {fields?.map((field) => (
          <div
            key={field.name}
            className={field.grid || "col-span-12 sm:col-span-6"}
          >
            <label className="block mb-2 text-md font-medium text-gray-800 tracking-wide capitalize">
              {field.label}
              {field.required && (
                <FaStarOfLife className="inline text-red-500 ml-1 w-2 h-2" />
              )}
            </label>

            <InputField
              // label={field.label}
              type={field.type}
              name={field.name}
              value={formData[field.name]}
              onChange={(val) => handleInputChangeWithValidation(val, field)}
              placeholder={field.placeholder || `Enter ${field.label}`}
              // error={errors[field.name]}
              required={field.required}
              disabled={field.disabled}
              options={field.options}
              onAddNewClick={field.onAddNew}
              previewUrl={field.name === "image_Upload" ? previewUrl : null}
              min={field.min}
              max={field.max}
              step={field.step}
              accept={field.accept}
            />

            {errors[field.name] && (
              <p className="text-red-500 text-xs mt-1">{errors[field.name]}</p>
            )}
          </div>
        ))}
      </div>

      <div className="flex justify-end gap-4 py-4 mt-6 border-t border-gray-200 bg-white z-50">
        <Button
          text="Clear"
          icon={IoMdClose}
          iconPosition="left"
          className="text-primary font-semibold bg-gray-100 rounded-md p-2 border border-gray-300"
          iconSpacing="pr-1"
          onClick={onClear}
        />

        <Button
          text={isEditing ? "Update & Add New" : "Save & Add New"}
          icon={BsSave2}
          iconPosition="left"
          iconColor="text-black"
          className="text-black font-semibold bg-orange/50 rounded-md p-2 border border-orange/80"
          iconSpacing="pr-3"
          onClick={handleSaveAndAddNew}
        />

        <Button
          text={isEditing ? "Update" : "Submit"}
          icon={FaPaperPlane}
          iconPosition="left"
          iconColor="text-black"
          className="text-black font-semibold bg-orange rounded-md p-2 border border-orange/80"
          iconSpacing="pr-2"
          type="submit"
          onClick={handleSubmit}
        />
      </div>
    </form>
  );
};

export default FormFields;
